import styles from 'styles/VideoScreen.module.css'

type VideoScreenProps = {
  videoUrl: string;
  videoPoster: string;
  heading?: string;
  videoRef: any;
  loop?: boolean;
  studentOutputGifUrl: string;
}

function VideoScreen ({ videoUrl, videoPoster, heading, videoRef, loop, studentOutputGifUrl} : VideoScreenProps) {
  return (
    <div className={styles.container}>
      <div className={heading ? styles.heading : styles.hidden}>
      { heading }
      </div>
      <div className={styles.megaContainer}>
        <div className={styles.videoContainer}>
{/*          <video
            loop={loop}
            ref={videoRef}
            id="videoElement"
            src={videoUrl}
            controls
            poster={videoPoster}
            className={styles.video}
            preload='auto'
          />*/}
          <img
            src={studentOutputGifUrl}
            alt='Student Output'
            className={styles.video}
          />
        </div>
      </div>
    </div>
  )
}

export default VideoScreen;
